import React, { useState, useEffect } from "react";
import ItemInfo from "./ItemInfo";
import MonsterLootViewer from "./MonsterLootViewer";
import { Tabs, Tab, Box, Container } from "@mui/material";

export default function AppRoot() {
  const [itemList, setItemList] = useState([]);
  const [entityList, setEntityList] = useState([]);
  const [tab, setTab] = useState(0);



  useEffect(() => {
    async function getData() {
      const urlStr =
        "https://raw.githubusercontent.com/PhamKun/mcfc-web-res/refs/heads/release/mcfc.wts";

      try {
        const response = await fetch(urlStr);
        const data = await response.text();

        const entityReg =
          /\/\/\sUnits:\s(.{1,100})\s\((.{1,100})\),\sName\s\(Name\)/g;
        const entityData = [...data.matchAll(entityReg)];
        const tempEntityArr = entityData.map((match) => ({
          id: match[1],
          name: match[2].includes('Sandy Rocks')? 'Sandy Rocks' : match[2],
        }));
        setEntityList(tempEntityArr);
        const itemReg =
          /\/\/ Items: (.*?)\s\((.*?)\), Ubertip \(Tooltip - Extended\)\r?\n\{\r?\n([\s\S]*?)\r?\n\}/g;
        const itemMatches = [...data.matchAll(itemReg)];
        const tempItemArr = itemMatches.map((match) => {
        const typeRegex = /\|n\|cff[0-9a-fA-F]{6}([^\|]+)\|r/;
        let typeMatch = match[3].match(typeRegex) ? match[3].match(typeRegex) : match[2].match(/(?<type>spell|summmon|summmoning)/i);
        console.log(typeMatch, match[2]);
        return {
          id: match[1],
          name: match[2],
          description: match[3].replace(/\|n\|cff[0-9a-fA-F]{6}([^\|]+)\|r/, ''),
          type: typeMatch !== null ? (typeMatch[1] ? typeMatch[1] : "None") : "None",
          enchanced: data.includes("Enchanced " + match[2]),
        };
      });
        setItemList(tempItemArr);
      } catch (error) {
        console.error("Error fetching or parsing data:", error);
      }
    }

    getData();
  }, []);
  

  return (
    <Container maxWidth="md" sx={{ mt: 4 }}>
      <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
        <Tabs
          value={tab}
          onChange={(e, newVal) => setTab(newVal)}
          textColor="primary"
          indicatorColor="primary"
          centered
        >
          <Tab label="Monster Loot Viewer" />
          <Tab label="Item Info" />
        </Tabs>
      </Box>

      <Box sx={{ mt: 3 }}>
        {tab === 0 && <MonsterLootViewer entityList={entityList} itemList={itemList} />}
        {tab === 1 && <ItemInfo itemList={itemList} tab={tab}  setTab={setTab} />}
      </Box>
    </Container>
  );
}
